module.exports = __webpack_public_path__ + "static/media/kids_50.dd6c96a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_50.jpg
// module id = 5906
// module chunks = 0